import { useCallback, useEffect, useState } from "react";
import MonthVolumeAnalysis from "./MonthVolume";
import { getBessBessCostSummary } from "../../../../../../../Rest_api/RestApi";

export default function MonthAnalysis({
  selectedBlock,
  refreshKey,
  setError,
  selectedScenarios,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  selectedScenarios: Array<{ scenario_id: number; scenario_number: number }>;
}) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);

  const handleFetchData = useCallback(async () => {
    try {
      setLoading(true);

      if (selectedScenarios && selectedScenarios.length > 0) {
        const scenarioIds = selectedScenarios.map((s) => s.scenario_id);
        const res = await getBessBessCostSummary(scenarioIds);


        let finalData = [];
        if (Array.isArray(res)) {
          finalData = res;
        } else if (res && res.scenarios && typeof res.scenarios === 'object') {
          // Handle specific structure: { scenarios: { "28": { ... }, "29": { ... } } }
          finalData = Object.values(res.scenarios);
        } else if (res && Array.isArray(res.data)) {
          finalData = res.data;
        } else if (res && Array.isArray(res.result)) {
          finalData = res.result;
        } else if (res && typeof res === 'object') {
          const keys = Object.keys(res);
          const arrayProp = keys.find(k => Array.isArray(res[k]));
          if (arrayProp) {
            finalData = res[arrayProp];
          } else {
            finalData = Object.values(res).filter(v => typeof v === 'object');
          }
        }

        setData(finalData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [setError, selectedScenarios]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData, refreshKey]);

  return (
    <>
      <div className="dash-card border border-[#718EBF1C] bg-white shadow-[rgba(149,157,165,0.2)_0px_8px_24px] w-full !min-h-[100%] rounded-2xl">
        <div className="flex justify-center items-center mb-1">
          <h2 className="chartHeading !text-sm">Scenario-Wise BESS Cost (Cr)</h2>
        </div>
        <MonthVolumeAnalysis loading={loading} data={data} />
      </div>
    </>
  );
}
